import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsToolbarComponent } from './transport-interventions-toolbar.component';
import {
  DxDateBoxModule,
  DxLoadPanelModule,
  DxSelectBoxModule,
  DxToolbarModule,
  DxValidationGroupModule,
  DxValidatorModule
} from 'devextreme-angular';

import {TransportInterventionsNavigationModule} from '../transport-interventions-navigation/transport-interventions-navigation.module';




@NgModule({
  declarations: [TransportInterventionsToolbarComponent],
    imports: [
        CommonModule,
        DxValidationGroupModule,
        DxToolbarModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxValidatorModule,
        DxLoadPanelModule,
        TransportInterventionsNavigationModule
    ],
  exports: [TransportInterventionsToolbarComponent]
})
export class TransportInterventionsToolbarModule { }
